var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AtomModal',{attrs:{"width":"60%","height":"90%","position-y":0.5,"name":"typeform-modal","show-close-button":true,"on-click-close":_vm.onClickClose,"show":true}},[_c('iframe',{class:_vm.css('iframe'),attrs:{"src":_vm.iframeSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }